import styled from 'styled-components'
import { Caption2 } from '../styled/typography/typography'
import colors from '../../configuration/colors'
import DeleteIcon from '../../static/images/icons/dashboard_clear.svg'
import HoverIcon from '../../static/images/icons/dashboard_clear_hover.svg'
import HoverDarkThemeIcon from '../../static/images/icons/close_btn_hover_white.svg'

export const JourneyName = styled(Caption2)`
  max-width: 375px;
  text-align: left;
  line-height: 1.3;
  display: flex;
  align-items: center;
  font-weight: 500;
`

export const MasterCourseName = styled(JourneyName).attrs({
  as: 'caption',
  montserrat: true
})`
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: ${props => props.color};
  margin-right: 15px;
`

export const ClearButton = styled.div`
  position: absolute;
  top: 0;
  right: 38px;
  z-index: 999;
  display: flex;
  align-items: center;

  .clear {
    cursor: pointer;
    width: 11px;
    height: 11px;
    color: ${colors.silver};
    background: 50% ${props => props.theme.selectBackground} no-repeat
      url(${DeleteIcon});

    &:hover {
      background: 50% ${props => props.theme.selectBackground} no-repeat
        url(${props =>
          props.theme.style === 'light' ? HoverIcon : HoverDarkThemeIcon});
    }
  }

  .line {
    border-right: ${props => props.theme.masterSelectBorder};
    height: 45px;
    width: 1px;
    margin-left: 15px;
  }
`

export const MCSelectWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-end;
`
